export class SeoHelper {
  static setMetaData(attr: string, key: string, value: string) {
    const element = document.querySelector(`meta[${attr}="${key}"]`);

    if (element) {
      element.setAttribute("content", value);
    } else {
      const meta = document.createElement("meta");
      meta.setAttribute(attr, key);
      meta.setAttribute("content", value);
      document.head.appendChild(meta);
    }
  }

  static setTwitterMetaData(key: string, value: string) {
    SeoHelper.setMetaData("name", `twitter:${key}`, value);
  }

  static setOgMetaData(key: string, value: string) {
    SeoHelper.setMetaData("property", `og:${key}`, value);
  }

  static setCanonical(url: string) {
    const link = document.querySelector(`link[rel="canonical"]`);

    if (link) {
      link.setAttribute("href", url);
    } else {
      const link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      link.setAttribute("href", url);
      document.head.appendChild(link);
    }
  }
}
